// eslint-disable-next-line no-restricted-imports -- File donde se definen los hooks tipados; aquí sí se permite importar los hooks crudos de react-redux.
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
